document.addEventListener('DOMContentLoaded', function () {
  const playButtons = document.querySelectorAll('.video-block__play-button');

  playButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const videoId = this.getAttribute('data-video-id');
      const video = document.getElementById(videoId);
      const wrapper = video.closest('.video-block__wrapper');

      if (video) {
        video.setAttribute('controls', 'controls');
        video.play();
        wrapper.classList.add('playing');
      }
    });
  });

  const videos = document.querySelectorAll('.video-block__player');
  videos.forEach((video) => {
    video.addEventListener('play', function () {
      const wrapper = this.closest('.video-block__wrapper');
      const hasCustomIcon = wrapper.querySelector('.video-block__play-button');

      if (wrapper) {
        wrapper.classList.add('playing');
        if (hasCustomIcon) {
          this.setAttribute('controls', 'controls');
        }
      }
    });

    video.addEventListener('pause', function () {
      const wrapper = this.closest('.video-block__wrapper');
      const hasCustomIcon = wrapper.querySelector('.video-block__play-button');

      if (wrapper) {
        wrapper.classList.remove('playing');
        if (hasCustomIcon) {
          this.removeAttribute('controls');
        }
      }
    });
  });
});
